import { z } from 'zod';
import type { components } from './schema';

// server専用runtimeをimportせず、生成された既存の公開人物/表示型を境界に使う。
export type ReaderCharacter = components['schemas']['Character'];
export type ReaderDisplayMode = NonNullable<components['schemas']['Scenario']['displayMode']>;

export const ApiCharacterZ = z.object({
  id: z.string(),
  name: z.string(),
  role: z.string(),
  color: z.string(),
  portraitUrl: z.string().nullable().optional(),
  want: z.string().max(280).optional(),
  need: z.string().max(280).optional(),
  flaw: z.string().max(280).optional(),
  ghost: z.string().max(280).optional(),
  truth: z.string().max(280).optional(),
});

export const ReaderDisplayModeZ = z.enum(['text_scroll', 'visual_novel']);
export const ReaderScenarioSnapshotZ = z.object({
  id: z.string(),
  title: z.string(),
  characters: z.array(ApiCharacterZ),
  generationMode: z.literal('pre-baked'),
  displayMode: ReaderDisplayModeZ,
  endingBackgroundColor: z.string().nullable(),
  endingTextColor: z.string().nullable(),
});

export const ReaderAssetZ = z.object({
  url: z.string().min(1),
  sha256: z.string().regex(/^[0-9a-fA-F]{64}$/),
});

export const VisualAssetsZ = z.discriminatedUnion('mode', [
  z.object({ mode: z.literal('legacy') }),
  z.object({
    mode: z.literal('versioned'),
    selectionDigest: z.string().regex(/^[0-9a-fA-F]{64}$/),
    backgroundsByNodeKey: z.record(ReaderAssetZ),
    standingBySpeakerId: z.record(z.record(ReaderAssetZ)),
    defaultStandingBySpeakerId: z.record(ReaderAssetZ),
    cutinsBySpeakerId: z.record(z.record(ReaderAssetZ)),
  }),
]);

export const FixedReaderContextZ = z.object({
  fixedContentVersionId: z.string(),
  scenario: ReaderScenarioSnapshotZ,
  visualAssets: VisualAssetsZ,
});
export type FixedReaderContext = z.infer<typeof FixedReaderContextZ>;
